import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;

export { jQuery as $, jQuery };
